





























































import { Vue, Component } from "vue-property-decorator";
import { RecruitService } from "@/zh-website/src/views/Recruit/service";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
@Component({
  components: {
    ReadTo
  }
})
export default class Resume extends Vue {
  popup = false; //
  timer: any = null;
  countDown = 0;

  limit = 1;
  fileList = [];
  detail = {};
  titleName = "";
  link = "";
  email = "";

  fordata = {};
  isCheck = false;
  mounted() {
    this.geDetail();
    if (this.$route.params.type == "1") {
      //社会招聘
      this.titleName = "社会招聘";
      this.link = "/home/recruit/social";
      this.email = "hdshezhaozjhw@huawei.com";
    } else {
      //校园招聘
      this.titleName = "校园招聘";
      this.link = "/home/recruit/campus";
      this.email = "hdxiaozhaozjhw@huawei.com";
    }
  }

  geDetail() {
    RecruitService.getRecruitDetail({
      positionId: this.$route.params.aid
    }).then((res: any) => {
      this.detail = res.data;
    });
  }
  goBack() {
    this.$router.go(-1)
  }
}
